document.addEventListener('DOMContentLoaded', function () {
  const backButton = document.querySelector('.back-button');
  const urlParams = localStorage.getItem('urlParams');
  if (urlParams) {
    backButton.classList.remove("hidden");
    backButton.setAttribute("href", urlParams);
  } else if (typeof history !== 'undefined' && typeof history.back === 'function') {
    backButton.classList.remove("hidden");
    backButton.addEventListener('click', function (event) {
      event.preventDefault();
      history.back();
    });
  }
});